import { CompanyFormType, CompanyType } from "../types/generalTypes";
import api from "./api";
import { getCompanyLogoByUrl } from "../utils/firebaseStorage";
import { authenticateWithFirebase } from "../utils/firebaseAuth";

export const getCompanyById = async (
  id: string
): Promise<CompanyType | null> => {
  try {
    const { data } = await api.get<CompanyType | null>(`/Companies/${id}`);

    if (data) {
      try {
        const firebaseLogoUrl = await getCompanyLogoByUrl(
          data.logoUrl || null,
          id
        );
        if (firebaseLogoUrl) {
          data.logoUrl = firebaseLogoUrl;
        }
      } catch (error) {
        console.log("Logo não encontrada no Firebase para empresa:", id);
      }
    }

    return data;
  } catch (error: any) {
    console.error(error.response?.data?.message || "Erro ao resgatar empresa");
    return null;
  }
};

export const getCompanyByPathRouteKey = async (
  pathRouteKey: string
): Promise<CompanyType | null> => {
  try {
    const { data } = await api.get<CompanyType | null>(
      `/Companies/routeKey/${pathRouteKey}`
    );

    if (data) {
      try {
        const firebaseLogoUrl = await getCompanyLogoByUrl(
          data.logoUrl || null,
          data.id
        );
        if (firebaseLogoUrl) {
          data.logoUrl = firebaseLogoUrl;
        }
      } catch (error) {
        console.log("Logo não encontrada no Firebase para empresa:", data.id);
      }
    }

    return data;
  } catch (error: any) {
    console.error(error.response?.data?.message || "Erro ao trazer empresa");
    return null;
  }
};

export const createCompany = async (payload: CompanyFormType) => {
  try {
    await api.post("/Companies", {
      ...payload,
    });

    const firebaseResponse = await authenticateWithFirebase();

    if (!firebaseResponse.success) {
      console.error(
        "Erro na autenticação do Firebase:",
        firebaseResponse.message
      );
    }

    return true;
  } catch (error: any) {
    console.error(error);
    return false;
  }
};

export const login = async (
  emailOrUser: string,
  password: string
): Promise<{
  message: string;
  companyId?: number;
  companyName?: string;
  token?: string;
  success: boolean;
} | null> => {
  try {
    const { data } = await api.post("/Companies/login", {
      emailOrUser,
      password,
    });
    return data;
  } catch (error: any) {
    console.error(error.response?.data?.message || "Erro ao realizar login");
    return null;
  }
};

export const updatePathRouteKey = async (
  companyId: number | string,
  pathRouteKey: string
): Promise<{
  success: boolean;
  message: string;
}> => {
  try {
    const { data } = await api.patch(`/Companies/${companyId}/pathRouteKey`, {
      pathRouteKey,
    });
    return {
      success: true,
      message: data.message || "Link personalizado atualizado com sucesso.",
    };
  } catch (error: any) {
    console.error(
      error.response?.data?.message || "Erro ao atualizar link personalizado"
    );
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "Erro ao atualizar link personalizado.",
    };
  }
};

export const updateCompanyColors = async (
  companyId: number | string,
  primaryColor: string,
  secondaryColor: string
): Promise<{
  success: boolean;
  message: string;
}> => {
  try {
    const { data } = await api.patch(`/Companies/${companyId}/colors`, {
      primaryColor,
      secondaryColor,
    });
    return {
      success: true,
      message: data.message || "Cores da empresa atualizadas com sucesso.",
    };
  } catch (error: any) {
    console.error(
      error.response?.data?.message || "Erro ao atualizar cores da empresa"
    );
    return {
      success: false,
      message:
        error.response?.data?.message || "Erro ao atualizar cores da empresa.",
    };
  }
};

export const updateCompanyLogo = async (
  companyId: number | string,
  logoUrl: string
): Promise<{
  success: boolean;
  message: string;
}> => {
  try {
    const { data } = await api.patch(`/Companies/${companyId}/logo`, {
      logoUrl,
    });
    return {
      success: true,
      message: data.message || "Logo da empresa atualizado com sucesso.",
    };
  } catch (error: any) {
    console.error(
      error.response?.data?.message || "Erro ao atualizar logo da empresa"
    );
    return {
      success: false,
      message:
        error.response?.data?.message || "Erro ao atualizar logo da empresa.",
    };
  }
};

export const updateCompanyName = async (
  companyId: number | string,
  name: string
): Promise<{
  success: boolean;
  message: string;
}> => {
  try {
    const { data } = await api.patch(`/Companies/${companyId}/name`, {
      name,
    });
    return {
      success: true,
      message: data.message || "Nome da empresa atualizado com sucesso.",
    };
  } catch (error: any) {
    console.error(
      error.response?.data?.message || "Erro ao atualizar nome da empresa"
    );
    return {
      success: false,
      message:
        error.response?.data?.message || "Erro ao atualizar nome da empresa.",
    };
  }
};

export const updateDefaultWhatsAppMessage = async (
  companyId: number | string,
  defaultWhatsAppMessage: string
): Promise<{
  success: boolean;
  message: string;
}> => {
  try {
    const { data } = await api.patch(`/Companies/${companyId}/default-whatsapp-message`, {
      defaultWhatsAppMessage,
    });
    return {
      success: true,
      message: data.message || "Mensagem padrão atualizada com sucesso.",
    };
  } catch (error: any) {
    console.error(
      error.response?.data?.message || "Erro ao atualizar mensagem padrão"
    );
    return {
      success: false,
      message:
        error.response?.data?.message || "Erro ao atualizar mensagem padrão.",
    };
  }
};
